import React, { useState, useEffect } from "react";
import logo from "../../../../../assets/fe-images/logo.png";
import { Link, useLocation, useNavigate } from "react-router-dom";

const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (isHome && location.hash) {
      const id = location.hash.replace("#", "");
      setTimeout(() => scrollToSection(id), 80);
    }
  }, [isHome, location.hash]);

  const handleNavClick = (section) => {
    setMenuOpen(false);
    if (isHome) {
      scrollToSection(section);
      return;
    }
    navigate(`/#${section}`);
  };

  const navLinks = [
    { label: "Features", section: "features" },
    { label: "How It Works", section: "how-it-works" },
    { label: "MeetOcto For", section: "meetocto-for" },
    { label: "Pricing", section: "pricing" },
    { label: "FAQ", section: "faq" },
  ];

  return (
    <nav className={`landing-nav${scrolled ? " landing-nav--scrolled" : ""}`}>
      <div className="landing-nav__container">
        <Link to="/" className="landing-nav__logo" onClick={() => setMenuOpen(false)}>
          <img src={logo} alt="MeetOcto" />
        </Link>

        <ul className={`landing-nav__links${menuOpen ? " landing-nav__links--open" : ""}`}>
          {navLinks.map((link) => (
            <li key={link.section}>
              <button
                className="landing-nav__link-btn"
                onClick={() => handleNavClick(link.section)}
              >
                {link.label}
              </button>
            </li>
          ))}
        </ul>

        <div className="landing-nav__actions">
          <Link to="/admin/login">
            <button className="landing-nav__btn landing-nav__btn--login">Log In</button>
          </Link>
          <Link to="/signup">
            <button className="landing-nav__btn landing-nav__btn--signup">Get Started</button>
          </Link>
        </div>

        <button
          className={`landing-nav__hamburger${menuOpen ? " landing-nav__hamburger--open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {menuOpen && (
        <div className="landing-nav__mobile-menu">
          {navLinks.map((link) => (
            <button
              key={link.section}
              className="landing-nav__mobile-link"
              onClick={() => handleNavClick(link.section)}
            >
              {link.label}
            </button>
          ))}
          <div className="landing-nav__mobile-actions">
            <Link to="/admin/login" onClick={() => setMenuOpen(false)}>
              <button className="landing-nav__btn landing-nav__btn--login">Log In</button>
            </Link>
            <Link to="/signup" onClick={() => setMenuOpen(false)}>
              <button className="landing-nav__btn landing-nav__btn--signup">Get Started</button>
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};
